module.exports = __webpack_public_path__ + "static/media/mt_ln_2.10843281.png";